import { useCallback } from 'react';
import { createGlobalState } from 'react-use';
import useConfig from './useConfig';

const initialState = {
	uuid: '',
	lastActionTimestamp: '',
};

const useRecordState = createGlobalState(initialState);

const generateUUID = () => {
	return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

const useRecord = () => {
	const [state, setState] = useRecordState(initialState);
	const config = useConfig();

	const getUUID = useCallback(() => {
		const { Timeout } = config;
		let uuid = '';

		if (!state.uuid) {
			uuid = generateUUID();
			setState((state) => {
				return {
					...state,
					uuid,
					lastActionTimestamp: Date.now(),
				};
			});
		}

		if (state.uuid) {
			const now = Date.now();
			const lastActionTimestamp = state.lastActionTimestamp;
			const timeDiff = now - lastActionTimestamp;

			if (timeDiff > Timeout) {
				uuid = generateUUID();
				setState((state) => {
					return {
						...state,
						uuid,
						lastActionTimestamp: Date.now(),
					};
				});
			}

			if (timeDiff <= Timeout) {
				uuid = state.uuid;
				setState((state) => {
					return {
						...state,
						lastActionTimestamp: Date.now(),
					};
				});
			}
		}

		return uuid;
	}, [config, state.uuid, state.lastActionTimestamp, setState]);

	const makeRecord = useCallback(({ Action, Booth, Product, Keyword }) => {
		const params = new URLSearchParams(window.location.search);
		const location = params.get('location');
		const start = params.get('start');
		const Location = localStorage.getItem('Location') || location;
		const Start = localStorage.getItem('Start') || start;
		const uuid = getUUID();
		const { exhID, recordAPI, recordUser, recordPassword } = config;
		const record = {
			EXID: exhID,
			UUID: uuid,
			Action,
			Location,
			Booth: '',
			Keyword: '',
			Start: '',
			Product: '',
		};

		if (Action === 'F') {
			record.Booth = Booth;
		}

		if (Action === 'S') {
			record.Keyword = Keyword;
		}

		if (Action === 'N') {
			record.Start = Start;
			record.Booth = Booth;
		}

		if (Action === 'T') {
			record.Booth = Booth;
			record.Product = Product || '';
		}

		fetch(recordAPI, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Basic ' + btoa(`${recordUser}:${recordPassword}`),
			},
			body: JSON.stringify(record),
		});
	}, [config, getUUID]);

	return {
		makeRecord,
		userid: state.uuid,
		uuid: config.exhID,
	};
}
export default useRecord;